import React from 'react';

interface ValueWithAdjustmentProps {
    originalValue: number | string;
    adjustedValue: number | string | null;
    showAdjustedIfOriginalMissing?: boolean;
}

const ValueWithAdjustment: React.FC<ValueWithAdjustmentProps> = ({
                                                                     originalValue,
                                                                     adjustedValue,
                                                                     showAdjustedIfOriginalMissing = false
                                                                 }) => {

    const showAdjustment = adjustedValue != null && adjustedValue !== originalValue;

    return (
        <>
            {showAdjustedIfOriginalMissing && originalValue == null ? <>{adjustedValue}</> :
                showAdjustment ? (
                    <>
                        <s>{originalValue}</s>
                        <br />
                        <strong>{adjustedValue}</strong>
                    </>
                ) : (
                    <>{originalValue}</>
                )
            }
        </>
    );
};

export default ValueWithAdjustment;
